import { defineComponent as u, computed as r, openBlock as g, createBlock as h, unref as w, mergeProps as c, withCtx as l, renderSlot as a } from "vue";
import b from "./ghl-ui.es182.js";
const v = u({
  name: "UIInput"
}), B = u({
  ...v,
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: [String, Array],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: { type: String, default: void 0 },
    readonly: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 3
    },
    maxlength: Number,
    minlength: Number,
    loading: {
      type: Boolean
    },
    autosize: {
      type: [Boolean, Object]
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "large"
    },
    showCount: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    inputProps: {
      /** It can be any HTML `TextareaHTMLAttributes` and  `InputHTMLAttributes` */
      type: Object
    },
    showPasswordOn: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue", "onBlur", "onChange"],
  setup(e, { emit: d }) {
    const s = ["text", "textarea", "password"], n = e, p = d, m = r(() => s.includes(n.type) ? n.type : "text"), y = r(() => {
      if (!s.includes(n.type))
        return {
          type: n.type,
          ...n.inputProps
        };
      if (n.inputProps)
        return n.inputProps;
    });
    function f(t) {
      p("update:modelValue", t);
    }
    return (t, o) => (g(), h(w(b), c(t.$attrs, {
      id: e.id,
      clearable: e.clearable,
      disabled: e.disabled,
      loading: e.loading,
      maxlength: e.maxlength,
      minlength: e.minlength,
      placeholder: e.placeholder,
      readonly: e.readonly,
      rows: e.rows,
      "show-count": e.showCount,
      size: e.size,
      type: m.value,
      "input-props": y.value,
      value: e.modelValue,
      autosize: e.autosize,
      "show-password-on": e.showPasswordOn,
      "onUpdate:value": f,
      onOnBlur: o[0] || (o[0] = (i) => t.$emit("onBlur", i)),
      onOnChange: o[1] || (o[1] = (i) => t.$emit("onChange", i)),
      class: "hl-input-text font-sans"
    }), {
      prefix: l(() => [
        a(t.$slots, "prefix")
      ]),
      suffix: l(() => [
        a(t.$slots, "suffix")
      ]),
      "password-visible-icon": l(() => [
        a(t.$slots, "password-visible-icon")
      ]),
      "password-invisible-icon": l(() => [
        a(t.$slots, "password-invisible-icon")
      ]),
      _: 3
    }, 16, ["id", "clearable", "disabled", "loading", "maxlength", "minlength", "placeholder", "readonly", "rows", "show-count", "size", "type", "input-props", "value", "autosize", "show-password-on"]));
  }
}), P = B;
export {
  P as default
};
